"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypingIndicator = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const dot_styles_1 = require("@/components/common/dot/dot.styles");
/**
 * 입력 중(typing)·진행 중 상태를 나타내는 3-dot 모션.
 * 채팅 입력 표시, 응답 대기 등에 사용합니다.
 */
let TypingIndicator = class TypingIndicator extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.ariaLabel = '입력 중';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'status');
    }
    render() {
        return (0, lit_1.html) `
      <span></span>
      <span></span>
      <span></span>
    `;
    }
};
TypingIndicator.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
      gap: var(--space-1);
    }

    /* 점은 dot 계열의 크기 단계에서 고르고, 색은 놓인 자리의 글자색을 따른다. */
    span {
      ${dot_styles_1.dotStyles}
      --dot-size: ${(0, lit_1.unsafeCSS)(dot_styles_1.dotSizes['6'])};
      --dot-background-color: currentColor;

      animation: chatting 0.6s 0s ease infinite;
    }

    span:nth-of-type(2) {
      animation-delay: var(--animation-delay-first);
    }
    span:nth-of-type(3) {
      animation-delay: var(--animation-delay-second);
    }

    @keyframes chatting {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(0.125rem);
      }
      100% {
        transform: translateY(0);
      }
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label', reflect: true })
], TypingIndicator.prototype, "ariaLabel", void 0);
TypingIndicator = __decorate([
    (0, decorators_js_1.customElement)('mm-typing-indicator')
], TypingIndicator);
exports.TypingIndicator = TypingIndicator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwaW5nLWluZGljYXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInR5cGluZy1pbmRpY2F0b3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNEO0FBQ3RELHFEQUEyRDtBQUUzRCxtRUFBd0U7QUFFeEU7OztHQUdHO0FBRUksSUFBTSxlQUFlLEdBQXJCLE1BQU0sZUFBZ0IsU0FBUSxnQkFBVTtJQUF4Qzs7UUFtQytELGNBQVMsR0FBRyxNQUFNLENBQUE7SUFjeEYsQ0FBQztJQVpDLGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLFFBQVEsQ0FBQyxDQUFBO0lBQ3JDLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7OztLQUlWLENBQUE7SUFDSCxDQUFDOztBQS9DTSxzQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7OztRQVFiLHNCQUFTO29CQUNHLElBQUEsZUFBUyxFQUFDLHFCQUFRLENBQUMsR0FBRyxDQUFDLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQXdCekMsQ0FBQTtBQUNtRTtJQUFuRSxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxZQUFZLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO2tEQUFtQjtBQW5DM0UsZUFBZTtJQUQzQixJQUFBLDZCQUFhLEVBQUMscUJBQXFCLENBQUM7R0FDeEIsZUFBZSxDQWlEM0I7QUFqRFksMENBQWUifQ==